<template>
  <section id="casos">
    <div class="wrap">
      <div class="section-head">
        <div class="left">
          <span class="eyebrow"><span class="dot"></span>{{ labelsState['lv_cases_eyebrow'] || 'Use cases' }}</span>
          <h2>{{ labelsState['lv_cases_heading_pre'] || 'Built for teams that' }} <span class="grad-text">{{ labelsState['lv_cases_heading_grad'] || "never stop." }}</span></h2>
        </div>
        <div class="right">{{ labelsState['lv_cases_desc'] || 'From dental clinics to multi-store retail. The same platform adapts to every industry operation.' }}</div>
      </div>
      <div class="cases">
        <article class="case lg">
          <div class="case-graphic">+</div>
          <span class="case-tag">{{ labelsState['lv_case_health_tag'] || 'Health · Wellness' }}</span>
          <h3>{{ labelsState['lv_case_health_title'] || '24/7 scheduling with automatic confirmation' }}</h3>
          <p style="font-size:14px; color:var(--t-1)">
            {{ labelsState['lv_case_health_body'] || 'Reduce no-shows by 38%. Confirm, reschedule and collect deposits via WhatsApp with automated reminder flows.' }}
          </p>
          <ul>
            <li>{{ labelsState['lv_case_health_specialist_rules'] || 'Rules per specialist' }}</li>
            <li>{{ labelsState['lv_case_health_calendar_sync'] || 'Google Calendar sync' }}</li>
            <li>{{ labelsState['lv_case_health_payments'] || 'Payments with Stripe / Mercado Pago' }}</li>
          </ul>
        </article>
        <article class="case">
          <div class="case-graphic" style="background: linear-gradient(135deg, var(--cyan), var(--indigo))">$</div>
          <span class="case-tag">{{ labelsState['lv_case_retail_tag'] || 'Retail · eCommerce' }}</span>
          <h3>{{ labelsState['lv_case_retail_title'] || 'From DM to sale without friction' }}</h3>
          <p style="font-size:14px; color:var(--t-1)">{{ labelsState['lv_case_retail_body'] || 'Capture intent from Instagram and close inside the same chat.' }}</p>
        </article>
        <article class="case">
          <div class="case-graphic" style="background: linear-gradient(135deg, var(--magenta), var(--violet))">★</div>
          <span class="case-tag">{{ labelsState['lv_case_services_tag'] || 'Services' }}</span>
          <h3>{{ labelsState['lv_case_services_title'] || 'Qualify leads before passing them on' }}</h3>
          <p style="font-size:14px; color:var(--t-1)">{{ labelsState['lv_case_services_body'] || 'Automatic scoring and handover to the advisor with the full conversation.' }}</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useLabelsStore } from '@/stores/labels';
import { useLanguageStore } from '@/stores/language';

export default {
  name: 'CasesV2',
  setup() {
    const labelsStore = useLabelsStore();
    const languageStore = useLanguageStore();
    onMounted(() => labelsStore.fetchAndSetLabels(languageStore.language));
    return { labelsState: computed(() => labelsStore.labels) };
  },
};
</script>
